import { api } from '../services';
import config from '../config';

async function installInStation(email) {
  const response = await api.saveInstall(email);
  if (response.ok) {
    window.open(config.inStationStoreURL);
  }

  return { success: response.ok, data: response.data };
}

export default installInStation;
